import { render, staticRenderFns } from "./main-service-advantages.vue?vue&type=template&id=254c00be&scoped=true&"
import script from "./main-service-advantages.vue?vue&type=script&lang=ts&"
export * from "./main-service-advantages.vue?vue&type=script&lang=ts&"
import style0 from "./main-service-advantages.vue?vue&type=style&index=0&id=254c00be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c00be",
  null
  
)

export default component.exports